import { combineReducers } from '@reduxjs/toolkit'
import { api } from 'redux/api'
import authSlice from 'redux/store/slices/authSlice'
import decisionSlice from 'redux/store/slices/decisionSlice'
import loanSlice from 'redux/store/slices/loanSlice'
import statusSlice from 'redux/store/slices/statusSlice'
import userSlice from 'redux/store/slices/userSlice'
import wsSlice from 'redux/store/slices/wsSlice'

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  status: statusSlice,
  loan: loanSlice,
  ws: wsSlice,
  decision: decisionSlice,
  [api.reducerPath]: api.reducer
})

export default rootReducer
